<template>
  <div id="modalReplaceSupplierDocument" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Substituir Documento</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="replaceSupplierDocument">
          <div class="modal-body">
            <div class="row g-3">
              <div class="col-12">
                <label class="form-label">
                  Data de Vencimento: <span class="text-danger">*</span>
                </label>
                <input
                  type="date"
                  class="form-control"
                  :class="{
                    'is-invalid': v$.dataDocument.expireAt.$error,
                  }"
                  v-model="v$.dataDocument.expireAt.$model"
                />
                <span
                  v-if="v$.dataDocument.expireAt.required.$invalid"
                  class="invalid-feedback"
                >
                  O campo é obrigatório
                </span>
              </div>
              <div class="col-12">
                <label class="form-label">
                  Documento: <span class="text-danger">*</span>
                </label>
                <input
                  type="file"
                  class="form-control"
                  required
                  @change="onFilePicked"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              title="Confirmar"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Confirmar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { showModal, hideModal } from '@/utils/modal'
import { removeCnpjCharacteres } from '@/utils/strings'

export default {
  name: 'ReplaceSupplierDocumentModal',

  props: {
    document: {
      type: Object,
      required: true,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      dataDocument: reactive({ ...this.document }),
      disableButton: false,
    }
  },

  methods: {
    onFilePicked(event) {
      const { files } = event.target
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
        this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      const [file] = files
      this.dataDocument.file = file
    },

    async replaceSupplierDocument() {
      try {
        this.disableButton = true

        const formData = new FormData()
        formData.append('id', this.dataDocument.id)
        formData.append('previousId', this.dataDocument.previousId)
        formData.append('supplierName', this.dataDocument.supplierName)
        formData.append('supplierDocument', this.dataDocument.supplierDocument)
        formData.append('name', this.dataDocument.name)
        formData.append('expireAt', this.dataDocument.expireAt)
        formData.append('file', this.dataDocument.file)

        const response = await this.$store.dispatch('replaceSupplierDocument', {
          id: this.dataDocument.id,
          cgccfo: removeCnpjCharacteres(this.dataDocument.supplierDocument),
          formData,
        })

        hideModal()
        this.$emit('closeModal', true)
        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  validations() {
    return {
      dataDocument: {
        expireAt: {
          required,
        },
      },
    }
  },

  mounted() {
    showModal('modalReplaceSupplierDocument')
  },

  beforeUnmount() {
    hideModal()
    this.$emit('closeModal', false)
  },
}
</script>
